<template>
  <footer></footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>
